export const codes = {
  required: {message: ''}
}

export interface CodesList {
  required: string
}